// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/cloud/discovery/v1/environment_api.proto (package ai.h2o.cloud.discovery.v1, syntax proto3)
/* eslint-disable */

import type { Environment } from "./environment_pb";
import { RPC } from "../../../../../runtime";

/**
 * @generated from message ai.h2o.cloud.discovery.v1.GetEnvironmentRequest
 */
export type GetEnvironmentRequest = {
}
;
/**
 * @generated from message ai.h2o.cloud.discovery.v1.GetEnvironmentResponse
 */
export type GetEnvironmentResponse = {
/**
 * @generated from field: ai.h2o.cloud.discovery.v1.Environment environment = 1;
 */
environment?: Environment;
}
;
/**
 * @generated from rpc ai.h2o.cloud.discovery.v1.EnvironmentService.GetEnvironment
 */
export const EnvironmentService_GetEnvironment = new RPC<GetEnvironmentRequest,GetEnvironmentResponse>("GET", "/v1/environment");
